export { default as rateYourselfPNG } from '~/assets/images/anatomyV2/rate-yourself-organs.png'
export { default as rateYourselfWEBP } from '~/assets/images/anatomyV2/rate-yourself-organs.webp'

export const RATE_YOURSELF_QUESTION =
  'Rate yourself: how well do you understand anatomy?'
export const SECTION_NUMBER = 3

export const RATE_YOURSELF_OPTIONS = ['1', '2', '3', '4', '5'] as const
